/* Sticky ATC: keep theme show/hide + fade; only sync bottom to iOS visualViewport */
(function () {
  function syncBottom() {
    var vv = window.visualViewport;
    var gap = 0;
    if (vv) {
      gap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    }
    document.querySelectorAll('product-quick-add').forEach(function (el) {
      el.style.bottom = gap ? gap + 'px' : '';
    });
  }

  function run() {
    syncBottom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);

  if (window.visualViewport) {
    visualViewport.addEventListener('resize', syncBottom, { passive: true });
    visualViewport.addEventListener('scroll', syncBottom, { passive: true });
  }
})();
